export const chapters = [
  {
    id: 6,
    part: 1,
    englishTitle: "The Preliminaries",
    kanjiTitle: "tbd",
    romanizedTitle: "tbd",
    available: true,
    parts: [
        {
            englishTitle: "Uchiha Sasuke vs Gōmonjō Yoroi",
            romanizedTitle: "tbd",
            kanjiTitle: "tbd",
            label: "tbd", 
            available: true,
            content: `Content for Uchiha Sasuke vs Gōmonjō Yoroi...`
        },
        {
            englishTitle: "Abumi Zaku vs Aburame Shino",
            romanizedTitle: "tbd",
            kanjiTitle: "tbd",
            label: "tbd", 
            available: false,
            content: `Content for Abumi Zaku vs Aburame Shino...`
        },
        {
            englishTitle: "Kankurō vs Hana Shiore",
            romanizedTitle: "tbd",
            kanjiTitle: "tbd",
            label: "tbd", 
            available: false,
            content: `Content for Kankurō vs Hana Shiore...`
        },
        {
            englishTitle: "Nara Shikamaru vs Tsuchi Kin",
            romanizedTitle: "tbd",
            kanjiTitle: "tbd",
            label: "tbd", 
            available: false,
            content: `Content for Nara Shikamaru vs Tsuchi Kin...`
        },
        {
            englishTitle: "Uzumaki Naruto vs Inuzuka Kiba",
            romanizedTitle: "tbd",
            kanjiTitle: "tbd",
            label: "tbd", 
            available: false,
            content: `Content for Uzumaki Naruto vs Inuzuka Kiba...`
        },
        {
            englishTitle: "Temari vs Tenten",
            romanizedTitle: "tbd",
            kanjiTitle: "tbd",
            label: "tbd",
            available: false, 
            content: `Content for Temari vs Tenten...`
        },
        {
            englishTitle: "Hyūga Neji vs Hyūga Hinata",
            romanizedTitle: "tbd",
            kanjiTitle: "tbd",
            label: "tbd", 
            available: false,
            content: `Content for Hyūga Neji vs Hyūga Hinata...`
        },
        {
            englishTitle: "Rock Lee vs Gaara",
            romanizedTitle: "tbd",
            kanjiTitle: "tbd",
            label: "tbd", 
            available: true,
            content: `Content for Rock Lee vs Gaara...`
        },
        {
            englishTitle: "Kinuta Dosu vs Akimichi Chōji",
            romanizedTitle: "tbd",
            kanjiTitle: "tbd",
            label: "tbd", 
            available: false,
            content: `Content for Kinuta Dosu vs Akimichi Chōji...`
        }
    ]
 }
];